import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { awsConfig } from './aws-config';
import { ThemeProvider } from './ThemeContext';  // NEW: Theme provider
// import HomePage from './pages/HomePage';  // OLD: Original home page (commented out)
import QueueSelectionPage from './pages/QueueSelectionPage';  // NEW: Queue selection page
import MultiQueueWallboardPage from './pages/MultiQueueWallboardPage';  // NEW: Multi-queue dashboard
import SharedWallboardPage from './pages/SharedWallboardPage';
import './App.css';

Amplify.configure(awsConfig);

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/shared/:linkId" element={<SharedWallboardPage />} />
          <Route
            path="/*"
            element={
              <Authenticator>
                {({ signOut }) => (
                  <Routes>
                    <Route path="/" element={<QueueSelectionPage signOut={signOut} />} />  {/* NEW: Queue selection */}
                    {/* <Route path="/" element={<HomePage signOut={signOut} user={user} />} />  OLD: Original home (commented out) */}
                    <Route path="/multi-queue/:queueIds" element={<MultiQueueWallboardPage signOut={signOut} />} />  {/* NEW: Multi-queue dashboard */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                )}
              </Authenticator>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
